import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import MainLayout from '@/common/components/layouts/MainLayout';
import UploadImageCard from '@/common/components/uploadImage/UploadImageCard';
import LoadingPage from '@/common/pages/LoadingPage';
import { deleteCroquisSketchQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteCroquisSketch/deleteCroquisSketchQueryOptions';
import { getCulpritCroquisSketchQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCroquisSketch/getCulpritCroquisSketchQueryOptions';
import { PostCroquisSketchQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postCroquisSketch/postCroquisSketchQuery.type';
import { postCroquisSketchQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postCroquisSketch/postCroquisSketchQueryOptions';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';
import TickIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/greenBorderdTick.svg?react';
export default () => {
  return (
    <MainLayout title="مقصر / تصاویر" header="titleHeader">
      <CulpritCroquisPage />
    </MainLayout>
  );
};

const CulpritCroquisPage = () => {
  const queryClient = useQueryClient();
  const { id } = useParams();
  const [uploadLoadingId, setUploadLoadingId] = useState<string | null>(null);

  const { data, isPending } = useQuery(
    getCulpritCroquisSketchQueryOptions({
      id: id!,
      onSuccess: () => {
        setUploadLoadingId(null);
      },
    }),
  );

  const { mutateAsync, isPending: uploadLoading } = useMutation(
    postCroquisSketchQueryOptions(),
  );
  const { mutateAsync: deleteMutateAsync, isPending: deleteImageLoading } =
    useMutation(deleteCroquisSketchQueryOptions());

  const refetchImages = () => {
    queryClient.invalidateQueries({
      queryKey: getCulpritCroquisSketchQueryOptions({ id: id! }).queryKey,
    });
  };

  const uploadImage = ({
    image,
    title,
  }: {
    image: Blob;
    title: PostCroquisSketchQueryParamsType['data']['title'];
  }) => {
    setUploadLoadingId(title);

    mutateAsync({ id: id!, data: { image, title } }).then(() => {
      refetchImages();
    });
  };

  const deleteImage = async (id: string) => {
    return deleteMutateAsync({ id }).then(() => {
      refetchImages();
      return true;
    });
  };

  return (
    <Box pt="1.5rem">
      <TitleDescription>کروکی</TitleDescription>
      <Typography color="black-1" textStyle="b2" mt="1.5rem">
        کارشناس محترم، در صورت داشتن کروکی حادثه و گزارش انتظامی آن را بارگذاری
        نمایید.
      </Typography>
      {data?.[0].photographer === 'self' ? (
        <Flex
          p={'0.8rem'}
          textAlign="center"
          borderRadius="10px"
          backgroundGradient="to-r"
          gradientFrom="#E9FEF5"
          gradientTo="transparent"
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Box flex={1} mr="1rem">
            <TickIcon width={50} />
          </Box>
          <Typography flex={4} color="green-1" textStyle="b1">
            کارشناس محترم ، تصویر کروکی توسط مشتری بارگذاری شده است.
          </Typography>
        </Flex>
      ) : null}
      <Flex
        gap="1rem"
        maxWidth="maxContainer"
        margin="auto"
        className={grid({ columns: isPending ? 1 : 2 })}
        mt={'1.5rem'}
      >
        {isPending ? (
          <LoadingPage />
        ) : (
          data?.map((image) => {
            return (
              <UploadImageCard
                selectFromGallery
                onUploadImage={({ closeModal, imageData }) => {
                  uploadImage({
                    image: imageData.blob,
                    title: image.title.const,
                  });
                  closeModal();
                }}
                onDeleteImage={({ closeModal }) => {
                  deleteImage(image.id!.toString()).then(() => {
                    closeModal();
                  });
                }}
                onEditImage={({ closeModal, imageData }) => {
                  uploadImage({
                    image: imageData.blob,
                    title: image.title.const,
                  });
                  closeModal();
                }}
                title={image.title.fa_const}
                deleteImageLoading={deleteImageLoading}
                key={image.title.const}
                imageData={image}
                uploadImageLoading={
                  image.title.const === uploadLoadingId && uploadLoading
                }
              />
            );
          })
        )}
      </Flex>
    </Box>
  );
};
